import React, { FC } from 'react'
import './EducationalImpactLanding.scss'
import EducationalImpact from './components/EducationalImpact'
import ClientCompanies from './components/ClientCompanies/ClientCompanies'
import { TypeSlugLanding } from 'app_types/admin/landings/landingTypes'

interface IEducationalImpactLandingProps {
  slug: TypeSlugLanding
}

const EducationalImpactLanding: FC<IEducationalImpactLandingProps> = ({
  slug
}) => {
  return (
    <div className='educational-impact--container'>
        <EducationalImpact/>
        <ClientCompanies slug={slug} />
    </div>
  )
}

export default EducationalImpactLanding
